import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(Auth)/(home)/page.js")